export const ApplicationOption = {
	ZEF: 'zef',
	PZE: 'pze',
	SETTINGS: 'settings',
};
